// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file shard.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file shard.proto.
 */
export const file_shard: GenFile =
  /*@__PURE__*/
  fileDesc(
    'CgtzaGFyZC5wcm90byInCgVTaGFyZBIPCgdjbHVzdGVyGAEgASgFEg0KBWluZGV4GAIgASgFIl4KD1B1YmxpY1NoYXJkSW5mbxINCgVjbG9jaxgBIAEoBBIUCgxjb21tdW5pdHlfaWQYAiABKAwSFQoFc2hhcmQYAyABKAsyBi5TaGFyZBIPCgdjaGFpbklkGAQgASgEIj4KGENvbW11bml0eVB1YmxpY1NoYXJkSW5mbxIRCglzaWduYXR1cmUYASABKAwSDwoHcGF5bG9hZBgCIAEoDGIGcHJvdG8z',
  )

/**
 * @generated from message Shard
 */
export type Shard = Message<'Shard'> & {
  /**
   * @generated from field: int32 cluster = 1;
   */
  cluster: number

  /**
   * @generated from field: int32 index = 2;
   */
  index: number
}

/**
 * Describes the message Shard.
 * Use `create(ShardSchema)` to create a new message.
 */
export const ShardSchema: GenMessage<Shard> =
  /*@__PURE__*/
  messageDesc(file_shard, 0)

/**
 * @generated from message PublicShardInfo
 */
export type PublicShardInfo = Message<'PublicShardInfo'> & {
  /**
   * clock
   *
   * @generated from field: uint64 clock = 1;
   */
  clock: bigint

  /**
   * community ID
   *
   * @generated from field: bytes community_id = 2;
   */
  communityId: Uint8Array

  /**
   * shard information
   *
   * @generated from field: Shard shard = 3;
   */
  shard?: Shard

  /**
   * if chainID > 0, the signer must be verified through the community contract
   *
   * @generated from field: uint64 chainId = 4;
   */
  chainId: bigint
}

/**
 * Describes the message PublicShardInfo.
 * Use `create(PublicShardInfoSchema)` to create a new message.
 */
export const PublicShardInfoSchema: GenMessage<PublicShardInfo> =
  /*@__PURE__*/
  messageDesc(file_shard, 1)

/**
 * @generated from message CommunityPublicShardInfo
 */
export type CommunityPublicShardInfo = Message<'CommunityPublicShardInfo'> & {
  /**
   * Signature of the payload field
   *
   * @generated from field: bytes signature = 1;
   */
  signature: Uint8Array

  /**
   * Marshaled PublicShardInfo
   *
   * @generated from field: bytes payload = 2;
   */
  payload: Uint8Array
}

/**
 * Describes the message CommunityPublicShardInfo.
 * Use `create(CommunityPublicShardInfoSchema)` to create a new message.
 */
export const CommunityPublicShardInfoSchema: GenMessage<CommunityPublicShardInfo> =
  /*@__PURE__*/
  messageDesc(file_shard, 2)
